// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import moment from 'moment';

import App from './view';
import router from './router';
import store from './store';

import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss';
import 'element-theme-dark';

moment.locale('zh-cn');

Vue.config.productionTip = false;

Vue.use(ElementUI);
ElementUI.Dialog.props.closeOnClickModal.default = false;
store.dispatch('common/getUserInfo').then(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });
});



// WEBPACK FOOTER //
// ./src/main.js